import { render, staticRenderFns } from "./DialogEmployeeTariff.vue?vue&type=template&id=c6e1b43a"
import script from "./DialogEmployeeTariff.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogEmployeeTariff.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports